import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { BaseApiService } from './base-api.service';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class CategoryService extends BaseApiService {
  constructor(
    private httpClient: HttpClient,
    private cookieService: CookieService,
  ) {
    super();
  }

  private baseUrl(): string {
    return this.apiUrl('/categories');
  }

  private getHeaders() {
    let headers = new HttpHeaders();
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append(
      'Authorization',
      'Bearer ' + this.cookieService.get(AuthenticationService.sessionKey),
    );
    return { headers };
  }

  list() {
    return this.httpClient.get<any>(this.baseUrl(), this.getHeaders());
  }

  get(id: string | number) {
    return this.httpClient.get<any>(`${this.baseUrl()}/${id}`, this.getHeaders());
  }

  create(payload: Record<string, any>) {
    return this.httpClient.post<any>(this.baseUrl(), payload, this.getHeaders());
  }

  update(id: string | number, payload: Record<string, any>) {
    return this.httpClient.put<any>(`${this.baseUrl()}/${id}`, payload, this.getHeaders());
  }

  delete(id: string | number) {
    return this.httpClient.delete<any>(`${this.baseUrl()}/${id}`, this.getHeaders());
  }
}
